import type { FeatureFlags } from './types'

export const DISTRICT_DEMO_PERSONA_ID = 'district'

type DistrictDemoProfile = 'dual_demo' | 'school' | 'academy'

/**
 * The selector is only a local demo affordance. It does not create, restore,
 * or authorize a District identity. Shared Browser builds have no verified
 * DistrictCapabilityLease, so neither preview nor dev mode may offer District.
 * The pure synthetic renderer/provider remains available to isolated tests.
 */
export function canOfferDistrictDemoPersona(input: {
  productProfile: DistrictDemoProfile
  demoToolsEnabled: boolean
  previewEnabled: boolean
  developerShellEnabled?: boolean
}): boolean {
  void input
  return false
}

export function canRenderDistrictDemoOverlay(input: {
  productProfile: DistrictDemoProfile
  demoModeEnabled: boolean
  activePersonaId: string
  flags: FeatureFlags
}): boolean {
  // Client flags/personas cannot substitute for the missing institutional lease.
  void input
  return false
}
